import { bl_wrty_warranty_certificate_hdr_RowClass, bl_wrty_warranty_certificate_hdr_RowInterface } from "../../../dbschema/bl_wrty_warranty_certificate_hdr.model";
import { BaseContainerModel } from "../../base-container.model";

export class WarrantyCertificateContainerModel extends BaseContainerModel {
  bl_wrty_warranty_certificate_hdr: bl_wrty_warranty_certificate_hdr_RowInterface = new bl_wrty_warranty_certificate_hdr_RowClass();
}